export enum responsiveScreenSizesEnum {
    tabScreenSize = 768,
    mobileLargeScreen = 425,
    mobileSmallScreen = 375,
}